/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITIALSTATE = {};

export default function areasReducer(state = INITIALSTATE, action) {
    let st = { ...state };

    switch (action.type) {
        case types.GET_CART:
            st = cloneState(state);
            st.cart = action.payload;
            delete st.cart_err;
            return st;

        case types.GET_CART_ERROR:
            st = cloneState(state);
            st.cart_err = action.payload;
            return st;
        default:
            return st;
    }
}
